import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { favoritesAPI } from '../api';
import AdCard from '../components/AdCard';
import LoadingSpinner from '../components/LoadingSpinner';

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [favIds, setFavIds] = useState(new Set());

  useEffect(() => {
    favoritesAPI.getAll()
      .then(res => {
        const items = res.data.favorites || [];
        setFavorites(items);
        setFavIds(new Set(items.map(f => `${f.item_type}_${f.item_id}`)));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleToggle = (type, id) => {
    const key = `${type}_${id}`;
    setFavIds(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
    setFavorites(prev => prev.filter(f => !(f.item_type === type && f.item_id === id)));
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="bg-gray-50/50 min-h-screen">
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5">
          <h1 className="text-xl font-bold text-gray-900">Saved Ads</h1>
          <p className="text-sm text-gray-500 mt-0.5">{favorites.length} item{favorites.length !== 1 ? 's' : ''} saved</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        {favorites.length === 0 ? (
          <div className="bg-white rounded-2xl border border-gray-100 p-16 text-center">
            <div className="text-5xl mb-4">❤️</div>
            <h3 className="text-lg font-bold text-gray-900 mb-1">No saved ads yet</h3>
            <p className="text-gray-500 text-sm mb-5">Tap the heart icon on any ad to save it here</p>
            <Link to="/" className="inline-block bg-primary-600 text-white px-6 py-2.5 rounded-xl font-semibold hover:bg-primary-700 transition-all shadow-md shadow-primary-500/20 text-sm">
              Browse Ads
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {favorites.map(f => (
              <AdCard
                key={`${f.item_type}_${f.item_id}`} item={f} type={f.item_type}
                isFav={favIds.has(`${f.item_type}_${f.item_id}`)}
                onToggleFav={() => handleToggle(f.item_type, f.item_id)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
